const { Fragment } = wp.element;
const { PanelBody, PanelRow, TextControl, FormToggle, SelectControl } = wp.components;
const { __ } = wp.i18n;

import BColor from "../../BColor";

const Watermark = ({ attributes, setAttributes }) => {
  const { type, enabled, text, color } = attributes.watermark || {};

  const handleWatermark = (property, value) => {
    setAttributes({ watermark: { ...attributes.watermark, [property]: value } });
  };

  return (
    <PanelBody title={__("Watermark", "h5vp")} initialOpen={false}>
      <PanelRow>
        <label class="label" for="watermark">
          {__("Watermark", "h5vp")}
        </label>
        <FormToggle id="watermark" checked={enabled} onChange={() => handleWatermark("enabled", !enabled)} />
      </PanelRow>
      {enabled && (
        <Fragment>
          {/* <PanelRow className="inline"> */}
          {/* <label htmlFor="" className="label">
              {__("Type")}
            </label> */}
          <SelectControl
            className="m-0"
            style={{ marginBottom: 0 }}
            value={type}
            labelPosition="side"
            label={__("Type", "h5ap")}
            options={[
              { label: "Uesr Email", value: "email" },
              { label: "User Name", value: "name" },
              { label: "Custom Text", value: "text" },
            ]}
            onChange={(type) => {
              handleWatermark("type", type);
            }}
            __nextHasNoMarginBottom
          />
          {["email", "name"].includes(type) && (
            <span>
              {__("only logged in user can see his/her ", "bpm")}
              {type}
            </span>
          )}
          {/* </PanelRow> */}
          {type === "text" && <TextControl value={text} onChange={(text) => handleWatermark("text", text)} />}

          <PanelRow>
            <label htmlFor="" className="label display-block">
              {__("Text Color", "h5vp")}
            </label>
            <BColor defaultColor="#f00" value={color} onChange={(color) => handleWatermark("color", color)} />
          </PanelRow>
        </Fragment>
      )}
    </PanelBody>
  );
};

export default Watermark;
